import { useShowUserCreditCard } from '@givebacks/api/core';
import { ButtonMantine, Card, Modal, Stack, Text, Title } from 'ui';

import { toTitleCase } from '../../../utils';
import { ExistingCreditCard } from '../../Cards';

type Props = {
  opened: boolean;
  onClose: () => void;
  credentialId: string;
  openRemoveModal: () => void;
};

const CredentialCardContent = ({
  credentialId,
  openRemoveModal,
}: {
  credentialId: string;
  openRemoveModal: () => void;
}) => {
  const { data: credential } = useShowUserCreditCard(credentialId);

  if (!credential) {
    return null;
  }

  return (
    <Stack gap="lg">
      <ExistingCreditCard credential={credential} />
      <Stack>
        <Title order={4}>Card Details</Title>
        <Card radius="sm" bd="1px solid gray.1">
          <Stack>
            <Stack gap="sm">
              <Text fz="sm" fw={600}>
                Card Number
              </Text>
              <Text fz="sm" c="gray">{`${toTitleCase(credential.card_type)} •••• ${
                credential.last_four
              }`}</Text>
            </Stack>
            <Stack gap="sm">
              <Text fz="sm" fw={600}>
                Expiration Date
              </Text>
              <Text fz="sm" c="gray">{`${credential.month}/${credential.year.slice(2, 4)}`}</Text>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      <ButtonMantine color="cerise" fullWidth onClick={openRemoveModal}>
        Remove Card
      </ButtonMantine>
    </Stack>
  );
};

const CredentialCardModal = ({ opened, onClose, credentialId, openRemoveModal }: Props) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Card On File">
      <CredentialCardContent credentialId={credentialId} openRemoveModal={openRemoveModal} />
    </Modal>
  );
};

export { CredentialCardModal };
